// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7l-0";
export var startPickingButton = "_7l-1";